import PropTypes from 'prop-types';
import cx from 'classnames';
import WillItFit from './WillItFit';
import { useSelector } from 'react-redux';
import FitmentResult from './FitmentResult';
import { FITMENT_VARIANTS as VARIANTS } from '../../../constants/commonConstants';

const ProductFitment = ({
  className,
  partNumber,
  variant,
  didFitmentCallResolve,
  getFitmentResult
}) => {
  const serialNumber = useSelector(
    s => s.myEquipment?.equipments?.selectedEquipment?.serialNumber
  );

  const shouldRenderVariant = Object.values(VARIANTS).includes(variant);
  const shouldRenderWillItFit = !serialNumber;

  if (shouldRenderVariant) {
    return (
      <div className={cx(className)}>
        {shouldRenderWillItFit ? (
          <WillItFit />
        ) : (
          <FitmentResult
            variant={variant}
            partNumber={partNumber}
            didFitmentCallResolve={didFitmentCallResolve}
            getFitmentResult={getFitmentResult}
          />
        )}
      </div>
    );
  } else {
    throw new Error(`unimplemented Product Fitment ${variant?.name}`);
  }
};

ProductFitment.propTypes = {
  variant: PropTypes.shape({
    name: PropTypes.string,
    iconSize: PropTypes.number,
    classes: PropTypes.string,
    showPopup: PropTypes.bool
  }).isRequired,
  partNumber: PropTypes.string.isRequired
};

export default ProductFitment;
